module.exports = __webpack_public_path__ + "img/cambridge_psychometrics.41dc292d.png";